module.exports = __webpack_public_path__ + "img/support_old.64869e5b.svg";